import * as React from 'react';
import { SVGProps } from 'react';

const IconKernFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 5c1.193 0 2.317-.18 3.18-.503.286-.107.567-.24.82-.402V9.5c0 .828-1.79 1.5-4 1.5s-4-.672-4-1.5V4.095c.253.162.534.295.82.402C3.683 4.82 4.807 5 6 5ZM2 2.5C2 1.672 3.79 1 6 1s4 .672 4 1.5S8.21 4 6 4s-4-.672-4-1.5Z" />
  </svg>
);
export default IconKernFilledSizeXs;
